export class PartitionField {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        },
        {
            "name": "transform",
            "baseName": "transform",
            "type": "PartitionTransform",
            "format": ""
        },
        {
            "name": "transformArg",
            "baseName": "transformArg",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PartitionField.attributeTypeMap;
    }
    constructor() {
    }
}
